import { FormState, FieldState } from 'formstate'
import { required, onlyNumericWithoutDecimal, minLength, maxLength } from '../../utils/forms'

class GetHolderInfoForm {
  fields = {
    receiverId: new FieldState('').validators(
      required,
      onlyNumericWithoutDecimal,
      minLength(1),
      maxLength(12)
    ),
  }

  form = new FormState(this.fields)

  serialize = () => {
    return {
      receiverId: this.fields.receiverId.$,
    }
  }
}

export { GetHolderInfoForm }
